const cookieNotification = {
    message: 'На этом сайте используются cookies',
    description: 'Подробнее',
    button: 'Хорошо',
};

export default cookieNotification;
